import hasPreviousCounters from './hasPreviousCounters'
//-----------------
// is valid action
//-----------------
export default async function isValidAction(parm) {
  console.log('--------------------------')
  console.log('IN isValidAction')
  return new Promise((resolve, reject) => {
    //-------------------------------------------------------------------
    // where:
    // (a) not on counters OR
    // (b) on counters BUT new action is remove counter (and is latest)
    // (c) on counters BUT new marker is counter
    // (d) not on counters BUT new marker is counter
    //-------------------------------------------------------------------
    //--------------------------------------------------------------------------------------
    // nothing blocking - can proceed e.g. no counters OR if counters this action = counter
    //--------------------------------------------------------------------------------------
    if (!parm.blocking) {
      console.log('isValidAction1 - no blockers: valid = TRUE')
      resolve(true)
      //-----------------------------------------------------
      // new action is remove counters - check prev counters
      //-----------------------------------------------------
    } else if (parm.selected_action && parm.selected_action.name == 'remove_counter') {
      console.log('isValidAction2 - new action is remove counters - check prev counters...')
      //----------
      // set parm
      //----------
      let previous_parm = {
        id: parm.id,
        round: parm.round,
        num: parm.num,
      }
      //-----------------------------
      // check for previous counters
      //-----------------------------
      let call = hasPreviousCounters(previous_parm)
      call
        .then((previousCounters) => {
          //-----------------------
          // has previous counters
          //-----------------------
          if (previousCounters) {
            console.log('isValidAction3 - has previous counters: valid = FALSE')
            resolve(false)
            //----------------------
            // no previous counters
            //----------------------
          } else {
            console.log('isValidAction4 - no previous counters: valid = TRUE')
            resolve(true)
          }
        })
        .catch((err) => {
          reject(err)
        })
      //---------------
      // is new marker
      //---------------
    } else if (parm.selected_marker) {
      console.log('isValidAction5 - new marker is counter: valid = TRUE')
      resolve(true)
      //---------
      // default
      //---------
    } else {
      console.log('isValidAction6 - default case: valid = FALSE')
      resolve(false)
    }
  })
}
